class CartListener { 
  constructor() {
    this.CART_LISTENER_KEY = "__cart_listener__";
    this.initVWO();
    this.initCartListener();
  }

  initVWO() {
    window.addEventListener("DOMContentLoaded", () => {
      window._vwo_code?.load?.();
      window.VWO = window.VWO || [];
      window.VWO.event =
        window.VWO.event || ((...args) => VWO.push(["event", ...args]));
    });
  }

  createCartListenerStore() {
    const initStore = {
      kv: {},
      created_at: Date.now(),
      total: 0,
      key: null,
    };
    sessionStorage.setItem(this.CART_LISTENER_KEY, JSON.stringify(initStore));
    return initStore;
  }

  getCartListenerStore() {
    try {
      let cartListenerStore = JSON.parse(
        sessionStorage.getItem(this.CART_LISTENER_KEY)
      );
      return cartListenerStore || this.createCartListenerStore();
    } catch (error) {
      console.error("Error parsing cart listener store:", error);
      return this.createCartListenerStore();
    }
  }

  saveCartListenerStore(store) {
    sessionStorage.setItem(this.CART_LISTENER_KEY, JSON.stringify(store));
  }

  sendEvent(event, cartData) {
    window.VWO.event(event, cartData);
  }

  compareChanges(store, cart) {
    const parsedCart = this.formatCart(cart);
    Object.entries(parsedCart.kv).forEach(([currKey, currValue]) => {
      const oldValue = store.kv[currKey];
      if (oldValue) {
        const qtyDifference = currValue.qty - oldValue.qty;
        if (qtyDifference !== 0) {
          const eventType =
            qtyDifference > 0 ? "addToCart" : "removeFromCart";
          this.sendEvent(eventType, {
            qty: Math.abs(qtyDifference),
            subTotal: qtyDifference > 0 ? oldValue.subTotal : parsedCart.total,
          });
          this.updateKV(store, currKey, currValue);
        }
      } else {
        this.sendEvent("addToCart", {
          qty: currValue.qty,
          subTotal: currValue.subTotal,
        });
        this.updateKV(store, currKey, currValue);
      }
    });
  }

  cartListenerHandler = (event) => {
    const cart = event.detail.cart;
    if (cart) {
      const store = this.getCartListenerStore();
      this.compareChanges(store, cart);
    }
  };

  initCartListener() {
    document.addEventListener("theme:cart:change", this.cartListenerHandler);
  }

  formatCart(cart) {
    const parsedCartToMatchStore = {
      created_at: Date.now(),
      total: parseFloat((cart.total_price / 100).toFixed(2)),
      key: cart.token,
      kv: {},
    };
    cart.items.forEach((item) => {
      parsedCartToMatchStore.kv[item.key] = {
        title: item.product_title,
        description: item.product_description,
        qty: item.quantity,
        id: item.product_id,
        subTotal: parseFloat((item.final_line_price / 100).toFixed()),
      };
    });
    return parsedCartToMatchStore;
  }

  updateKV(store, key, value) {
    store.kv[key] = value;
    this.saveCartListenerStore(store);
  }
}

const cartListenerInstance = new CartListener();
